"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatClassName = void 0;
const formatClassName = className => {
  if (!className) {
    return "";
  }
  if (className.includes("primary--") && !className.includes("ter-button")) {
    return `ter-button--${className}`;
  } else if (className.includes("secondary--") && !className.includes("ter-button")) {
    return `ter-button--${className}`;
  } else {
    return className;
  }
};
exports.formatClassName = formatClassName;